module.exports = __webpack_public_path__ + "img/pala_pickleball.3d82d8a6.png";